import { render, staticRenderFns } from "./pointTaskDetail.vue?vue&type=template&id=3a62b04c&scoped=true"
import script from "./pointTaskDetail.vue?vue&type=script&lang=js"
export * from "./pointTaskDetail.vue?vue&type=script&lang=js"
import style0 from "./pointTaskDetail.vue?vue&type=style&index=0&id=3a62b04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a62b04c",
  null
  
)

export default component.exports